import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'CmrContrPnlEditReading_Readings',
  props: {
    editingOptions: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    },
    modifyConsumption: {
      type: Boolean,
      default: false
    },
    editingReading: {
      type: Object,
      required: true
    },
    curReadingDisplay: {
      type: Object,
      required: true
    },
    prevReadingDisplay: {
      type: Object,
      required: true
    },
    readings: {
      type: Array,
      required: true
    }
  },
  components: {
    DisplayBasicInfo: require('./displayReadingBasicInfo/displayReadingBasicInfo.vue').default
  },
  data: function () {
    return {
      errorMessages: {
        lowCons: this.$t('captureMR.TooLowConsumption'),
        highCons: this.$t('captureMR.TooHighConsumption'),
        zeroCons: this.$t('captureMR.ZeroConsumption'),
        enableClockOver: this.$t('captureMR.ClockOverMustBeEnabled'),
        invalid: this.$t('captureMR.ValueIsinvalid'),
        negativeCons: this.$t('captureMR.NegativeConsumption'),
        subConsDif: this.$t('captureMR.SubconnectionsConsDifference')
      },
      hideRange: false,
    }
  },
  computed: {
    expectedRange: function () {
      if (this.hideRange)
        return '';

      if (this.editingOptions.customerMeterReadingUseQuarterType != true)
        return;

      if (this.editingReading.consumption == null || this.editingReading.consumption == '' || this.editingReading.consumption <= 0)
        return '';
      else if (this.editingReading.connType == 2) {
        if (this.editingReading.bulkAverageConsumptionDiffMin != null && this.editingReading.bulkAverageConsumptionDiffMax != null)
          return (", " + this.$t("captureMR.ExpectedRange") + " " + this.editingReading.bulkAverageConsumptionDiffMin + "-" + this.editingReading.bulkAverageConsumptionDiffMax);
        else
          return "";
      }
      else if (this.editingReading.similarPeriodConsumptionMin != null && this.editingReading.similarPeriodConsumptionMax != null)
        return (", " + this.$t("captureMR.ExpectedRange") + " " + this.editingReading.similarPeriodConsumptionMin + "-" + this.editingReading.similarPeriodConsumptionMax);
      else
        return "";
    },
  },
  watch: {
    //"curReadingDisplay.read": function (val) {
    //  this.readingValidations(this.editingReading);

    //  if (!val)
    //    return;

    //  this.editingReading.crReading = val;
    //  this.calculateConsumption();
    //},
    "curReadingDisplay.cons": function (val) {
      if (!val && this.modifyConsumption)
        return;

      this.editingReading.consumption = val;
    },
  },
  created() {
    this.$root.$on('cmr_edit_reading_changed', this.init)
    this.$root.$on('cmr_cur_reading_changed', (item) => this.curReadingChanged(item));
  },
  methods: {
    init() {
      this.readingValidations(this.editingReading);
    },
    curReadingChanged(val) {
      this.editingReading.crReading = val;

      this.calculateConsumption();
      this.readingValidations(this.editingReading);

    },
    calculateConsumption() {

      if (this.editingReading.prRead1 == 0) {
        this.editingReading.consumption = "";
        this.editingReading.curAvrCns = 0;
      }
      else {
        this.editingReading.consumption = this.editingReading.crReading - this.editingReading.prRead1;
        if (this.editingReading.clockOver) {
          let clockValue = "";
          for (let i = 0; i < this.editingReading.noDials; i++)
            clockValue = clockValue + "9";

          this.editingReading.consumption = this.editingReading.consumption + parseInt(clockValue);
        }

        var dCurrent = moment(this.editingReading.crDate);
        var dPrevious = moment(this.editingReading.prDate1);
        var iDiffDays = dCurrent.diff(dPrevious, 'days') + 1;

        //console.log("idif", iDiffDays)
        this.editingReading.curAvrCns = iDiffDays > 0 ? this.editingReading.consumption / iDiffDays : 0;
        this.editingReading["curAvrCnsDisplay"] = this.roundNumberV2(this.editingReading.curAvrCns, 4);
        this.editingReading["prAvrCnsDisplay"] = this.roundNumberV2(this.editingReading.prAvrCns, 4);

        //if (record.prAvrCns != null && record.prAvrCns != '' && (record.prAvrCns * 2) <= record.curAvrCns) {
        //  this.highConsumptionFlag = true;
        //}
        //else {
        //  this.highConsumptionFlag = false;
        //}

        this.curReadingDisplay.cons = this.editingReading.consumption;
        this.curReadingDisplay.avrgCons = this.editingReading.curAvrCns;
      }
    },
    readingValidations(value) {
      this.addMessagesToCurReading();

      var sClass = "";
      value.bMsgMin = false;
      value.bMsgMax = false;
      value.bZeroConsumption = false;
      value.bMsgNegative = false;
      value.bMsgInvalid = false;
      value.bMsgNegativeConsumption = false;

      //console.log("value", value);
      //console.log("value.consumption", value.consumption);
      //console.log("this.editingReading.prRead1", this.editingReading.prRead1);

      if (!value.crReading || value.crReading === "" || value.crReading === null ||
        value.crReading > Math.pow(10, value.noDials) - 1 || value.crReading < 0) {
        this.addMessagesToCurReading(this.errorMessages.invalid);
        this.hideRange = false;
        return;
      }

      if (value.consumption < 0) {
        this.addMessagesToCurReading(this.errorMessages.negativeCons);
        this.hideRange = false;
        return;
      }

      if (value.crReading == this.editingReading.prRead1) {
        this.addMessagesToCurReading(this.errorMessages.zeroCons);
        this.hideRange = false;
        return;
      }

      if (this.editingOptions.customerMeterReadingUseQuarterType == true) {
        //console.log("HHU val")
        //HHU validations

        if (this.editingOptions.billingHhuConsumptionWarningRange > 0) {
          let min;
          let max;
          let curConsumption = value.consumption;
          let curRead = value.crReading;
          let prevRead = value.prRead1;

          if (this.editingReading.connType == 2) { // Bulk meter
            let subReads = this.readings.filter((f) => f.bulkConnectionId == this.editingReading.connectionId);
            let prevCons = this.editingReading.previousConsumptions;
            let consumptions = [0, 0, 0, 0], avg = 0;
            let maxDiffPercent = this.editingOptions.billingHhuConsumptionWarningRange / 100.0;

            //add all 4 prec consumptions of each submeter
            subReads.forEach((s) => {
              consumptions[0] = consumptions[0] + s.prCons1;
              consumptions[1] = consumptions[1] + s.prCons2;
              consumptions[2] = consumptions[2] + s.prCons3;
              consumptions[3] = consumptions[3] + s.prCons4;
            })

            //find the diference between added submeter consumptions and the bulk meter
            for (let i = 0; i < 4; i++) {
              avg = avg + Math.abs(consumptions[i] - prevCons[i]);
            }

            //average of the difference
            avg = avg / 4;

            value.bulkAverageConsumptionDiffMin = parseInt(((1 - maxDiffPercent) * avg).toString(), 10);
            value.bulkAverageConsumptionDiffMax = parseInt(((1 + maxDiffPercent) * avg).toString(), 10);

            min = value.bulkAverageConsumptionDiffMin;
            max = value.bulkAverageConsumptionDiffMax;
          }
          else {
            min = value.similarPeriodConsumptionMin;
            max = value.similarPeriodConsumptionMax;
          }

          //console.log("value.bulkAverageConsumptionDiffMin", value.bulkAverageConsumptionDiffMin);
          //console.log("value.bulkAverageConsumptionDiffMax ", value.bulkAverageConsumptionDiffMax);
          //console.log("min", min);
          //console.log("max", max);
          //console.log("curConsumption", curConsumption);
          //console.log("curRead", curRead);
          //console.log("prevRead", prevRead);
          //console.log("value.prAvrCns", value.prAvrCns);
          //console.log("value.prCons1", value.prCons1);
          //console.log("value.prCons2", value.prCons2);
          //console.log("value.prCons3", value.prCons3);
          //console.log("value.prCons4", value.prCons4, '====> Avg ', (value.prCons1 + value.prCons2 + value.prCons3 + value.prCons4) / 4);

          //Checks
          if (curConsumption <= 0.01 || curRead > prevRead + max && value.prAvrCns > 0.01) {
            this.addMessagesToCurReading(this.errorMessages.highCons);
            this.hideRange = false;
            return;
          }

          let avrCons = (value.prCons1 + value.prCons2 + value.prCons3 + value.prCons4) / 4;
          if (2 * value.consumption <= avrCons) {
            this.addMessagesToCurReading(this.errorMessages.lowCons);
            this.hideRange = true;
            return;
          }

          if (curRead > prevRead && curRead < prevRead + min && value.prAvrCns > 0.01) {
            //prev + min
            this.addMessagesToCurReading(this.errorMessages.lowCons);
            this.hideRange = false;
            return;
          }
        }
      }
      else {
        //console.log("Non HHU val")
        if (value.curAvrCns == null || value.curAvrCns == '')
          value.curAvrCns = 0;
        if (value.prAvrCns == null || value.prAvrCns == '')
          value.prAvrCns = 0;

        //console.log("curAvrCns ", value.curAvrCns, " ----- prAvrCns ", value.prAvrCns)
        //console.log("lower lim", this.editingOptions.lowerConsumptionLimit, " ----- upper lim ", this.editingOptions.upperConsumptionLimit)
        //console.log("prAvrCns * lowerConsumptionLimit", value.prAvrCns, ' * ', this.editingOptions.lowerConsumptionLimit,' = ', value.prAvrCns * this.editingOptions.lowerConsumptionLimit)

        //validation for rest customers
        if (value.crReading < value.prRead1 && value.clockOver !== true) {
          this.addMessagesToCurReading(this.errorMessages.negativeCons);
          this.hideRange = false;
          return;
        }

        if (value.curAvrCns < value.prAvrCns * this.editingOptions.lowerConsumptionLimit) {
          this.addMessagesToCurReading(this.errorMessages.lowCons);
          this.hideRange = false;
          return;
        }

        if (value.curAvrCns >= value.prAvrCns * this.editingOptions.upperConsumptionLimit) {
          this.addMessagesToCurReading(this.errorMessages.highCons);
          this.hideRange = false;
          return;
        }
      }
    },
    roundNumberV2(value, decimals) {
      return Number(Math.round(Number(value + "e" + decimals)) + "e-" + decimals);
    },
    addMessagesToCurReading(msg = '') {
      if (!msg) {
        this.curReadingDisplay.messages = ' ';
        return;
      }

      if (this.editingOptions.customerMeterReadingUseQuarterType == true && this.expectedRange!= null && this.expectedRange.length > 0)
        msg = msg + this.expectedRange;

      this.curReadingDisplay.messages = msg != null && msg.length > 0 ? msg : ' ';
    },
  }
}
